<template>
  <FreeBottomSheet :name="name">
    <div class="space-y-6 p-4">
      <h2 class="text-text-neutral-primary text-xl font-semibold">Open Link</h2>

      <div class="space-y-4">
        <div class="space-y-3">
          <div class="flex space-x-2">
            <input
              v-model="customUrl"
              type="text"
              placeholder="Введите URL"
              class="bg-background-neutral-primary text-text-neutral-primary flex-grow rounded border px-3 py-2"
            />
            <button
              class="bg-background-positive-primary text-static-white hover:bg-background-info-accent rounded px-4 py-2 transition-colors"
              type="button"
              @click="navigateToUrl"
            >
              Перейти
            </button>
          </div>

          <div class="flex items-center justify-between">
            <span class="text-text-neutral-primary">Открыть в браузере</span>
            <FreeSwitch :checked="openInBrowser" @onChange="toggleMode" />
          </div>

          <div class="text-text-neutral-secondary">
            <p v-if="openInBrowser">Ссылка откроется в системном браузере</p>
            <p v-else>Ссылка откроется в WebView приложения</p>
          </div>
        </div>
      </div>
    </div>
  </FreeBottomSheet>
</template>

<script setup lang="ts">
  import { ref } from 'vue';
  import { FreeBottomSheet, FreeSwitch, freedomApp } from 'freedom-shared';

  interface Props {
    name: string;
  }

  defineProps<Props>();

  const customUrl = ref(window.location.href);
  const openInBrowser = ref(false);

  const toggleMode = () => {
    openInBrowser.value = !openInBrowser.value;
  };

  const navigateToUrl = () => {
    const url = customUrl.value.trim();

    if (!url) {
      alert('Пожалуйста, введите URL');
      return;
    }

    if (openInBrowser.value) {
      // Open in external browser
      freedomApp.lib.openInBrowser(url);
    } else {
      // Open in WebView (current window)
      window.location.href = url;
    }
  };
</script>
